let videos = document.querySelectorAll('.block_image_video .play-button.upload');

if (videos) {
    videos.forEach(function (el) {
        el.addEventListener('click', function () {
            this.parentElement.classList.add('play');
            this.nextElementSibling.play();
        });
    });
}
